import { ApiFormationsEventIdGet200ResponseDataFormationsAwayInnerInner } from '@/api/livescore/generated';
import LivescoreEntityLink from '@/components/atoms/LivescoreEntityLink/LivescoreEntityLink';
import { useLivescoreMatch } from '@/context/LivescoreMatchContext';
import { cn } from '@/utils/cn';
import { convertAlpha } from '@/utils/countryCode';
import Image from 'next/image';
import React from 'react';

const StarterItem = ({
  player,
  reverse,
}: {
  player: ApiFormationsEventIdGet200ResponseDataFormationsAwayInnerInner;
  reverse?: boolean;
}) => {
  const aplha = player.country_code ? convertAlpha(player.country_code) : '';

  return (
    <li>
      <LivescoreEntityLink
        href={`/livescore/player/${player.slug ? player.slug : player?.id?.split(':')[2]}`}
        className={cn('flex items-center gap-1', reverse ? 'flex-row-reverse' : '')}
      >
        {player.jersey_number ? <p className="text-[8px] sm:text-[11px]">{player.jersey_number}</p> : null}
        {aplha ? (
          <div className="w-[7px] h-[7px] sm:w-[10px] sm:h-[10px] rounded-full relative overflow-hidden">
            <Image
              src={`https://flagcdn.com/${aplha.toLocaleLowerCase()}.svg`}
              alt={aplha}
              layout="fill"
              objectFit="cover"
            />
          </div>
        ) : null}
        <p className="text-[8px] sm:text-[11px] font-semibold">{player.name}</p>
      </LivescoreEntityLink>
    </li>
  );
};

const Starters = () => {
  const { starters } = useLivescoreMatch();

  if (!starters?.home.length && !starters?.away.length) {
    return null;
  }

  return (
    <div className="mt-4 text-black dark:text-white">
      <h4 className="text-xs mb-2.5">Składy wyjściowe</h4>
      <div className="flex justify-between">
        <ul className="pl-0 list-none space-y-2 sm:space-y-2.5">
          {starters?.home.map((player) => (
            <StarterItem key={player.id} player={player} />
          ))}
        </ul>
        <ul className="pl-0 list-none space-y-2 sm:space-y-2.5">
          {starters?.away.map((player) => (
            <StarterItem key={player.id} player={player} reverse />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Starters;
